import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  blur () {
    const input = this.element.querySelector('input[type="search"]')
    if (input) input.blur()
    const results = this.element.querySelector('[data-autocomplete-target="results"]')
    if (results) {
      results.hidden = true
      results.innerHTML = ''
    }
  }
}
